import { Map as ImmutableMap } from 'immutable';

// @ts-expect-error Untyped import
import getProperties from './';
export const getProperty = (dataType, property) => {
  return getProperties(dataType).then(remoteProperties => remoteProperties.getIn([dataType, property], ImmutableMap()));
};
export function getPropertiesMap(dataType, properties) {
  return getProperties(dataType).then(remoteProperties => properties.reduce((memo, property) => memo.set(property, remoteProperties.getIn([dataType, property], ImmutableMap())), ImmutableMap()));
}